var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vector",
    _vm._b({}, "vector", _vm.$props, false),
    [
      _c(
        "human",
        _vm._b(
          {
            attrs: {
              keyframe: _vm.keyframe,
              sx: 0.1,
              sy: 0.1,
              x: -350,
              y: -290
            }
          },
          "human",
          _vm.barrelroll,
          false
        )
      ),
      _c("balloon", _vm._b({}, "balloon", _vm.barrelroll, false)),
      _c("do-a-barrel-roll", {
        attrs: { keyframe: _vm.keyframe },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(barrelroll) {
              return [
                _c(
                  "balloon",
                  _vm._b(
                    { attrs: { color: "green" } },
                    "balloon",
                    barrelroll,
                    false
                  )
                )
              ]
            }
          }
        ])
      }),
      _c("do-a-barrel-roll", {
        attrs: { keyframe: _vm.keyframe },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(barrelroll) {
              return [
                _c(
                  "human",
                  _vm._b(
                    {
                      attrs: {
                        keyframe: _vm.keyframe,
                        sx: 0.1,
                        sy: 0.1,
                        x: -100,
                        y: 170,
                        color: "orange"
                      }
                    },
                    "human",
                    barrelroll,
                    false
                  )
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }